<script setup lang="ts">
import { useI18n } from '#i18n';

import TokenAuthenticated from '../../assets/svg/token-authenticated.svg?component';

export type AuthenticatedTokenMessageProps = {
  timerStr: string,
  authenticatedToken: boolean,
};

const { t } = useI18n();

withDefaults(defineProps<AuthenticatedTokenMessageProps>(), {
  timerStr: '',
  authenticatedToken: false,
});

</script>

<template>
  <div
    v-if="authenticatedToken"
    :class="$style.tokenTimeCount"
    data-testid="authenticatedTokenMessage"
  >
    <div :class="$style.content">
      <div :class="$style.messageContainer">
        <TokenAuthenticated
          width="24px"
          data-testid="authenticatedTokenImg"
        />
        <span :class="$style.message">
          {{ t('requirement.token.authenticated') }}
        </span>
      </div>
      <span
        :class="$style.authTimer"
        data-testid="authenticatedTimer"
      >
        {{ timerStr }}
      </span>
    </div>
  </div>
  <small
    v-else
    :class="$style.timer"
    data-testid="expirationTokenMessage"
  >
    <span data-testid="expirationTimer">
      {{ $t('requirement.token.timer', { timer: timerStr }) }}
    </span>
  </small>
</template>

<style lang="scss" module>
  .tokenTimeCount{
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: var(--space-medium);
    border-radius: var(--border-radius-small);

    .content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      padding: var(--space-small-xx);
      text-align: left;
      background-color: #e4ffef;

      .messageContainer {
        display: flex;
        align-items: center;
        width: 100%;

        .message {
          margin-left: var(--space-small-xx);
        }
      }

      .authTimer {
        color: var(--color-neutral-700);

        @media (max-width: 799px) {
          margin-left: var(--space-small-xx);
        }
      }
    }
  }

  .timer {
    margin-bottom: var(--space-regular);
    text-decoration: underline;
    color: var(--color-neutral-700);
  }
</style>
